import {PrivacyBannerProps} from "./PrivacyBannerProps";
import {Button} from "@kaltura/ds-react-components";
import React, {useEffect, useState} from "react";
import ReactHtmlParser from "@mediaspace/shared/ui/html-react-parser";
import {generateGUID, kmsPlayerHelper, kmsCookie} from "@mediaspace/shared/utils";
import {StyledBanner, StyledMessage, StyledButtonsSection} from "./StyledComponents";

/**
 * Privacy Banner Component
 */
const PrivacyBanner = (props: PrivacyBannerProps) => {

    const {declineText, acceptText, bannerText} = props;

    const [showBanner, setShowBanner] = useState(false);

    const cookieName = "kms_upriv";

    const saveUserSelection = (sendStats: boolean) => {
        // save selection:
        const cookieValue = sendStats ? generateGUID() : "deny";
        const options = {
            expires: new Date("31 Dec 9999 23:59:59 GMT")
        };
        kmsCookie(cookieName, cookieValue, options);

        if (sendStats) {
            // if player on page should be updated
            kmsPlayerHelper.setPersistentSessionId(cookieValue);
        }

        setShowBanner(false);
    };

    useEffect(() => {
        // check if cookie exists
        if (!kmsCookie(cookieName)) {
            setShowBanner(true)
        }
    }, []);

    return (
        <>
            {showBanner && (
                <StyledBanner className="kms-ds-privacy-banner">
                    <StyledMessage className="kms-ds-privacy-banner-message">
                        {ReactHtmlParser(bannerText)}
                    </StyledMessage>
                    <StyledButtonsSection>
                        <Button
                            aria-label={declineText}
                            variant={"borderless"}
                            className={"kms-ds-privacy-banner-button-decline"}
                            onClick={() => {
                                saveUserSelection(false);
                            }}
                        >
                            {declineText}
                        </Button>
                        <Button
                            aria-label={acceptText}
                            variant={"pill"}
                            className={"kms-ds-privacy-banner-button-accept"}
                            onClick={() => {
                                saveUserSelection(true);
                            }}
                        >
                            {acceptText}
                        </Button>
                    </StyledButtonsSection>
                </StyledBanner>
            )}
        </>
    );
};

export default PrivacyBanner;
